/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataProvider } from './DataProvider';
import {
    DataProviderFromJSON,
    DataProviderFromJSONTyped,
    DataProviderToJSON,
    DataProviderToJSONTyped,
} from './DataProvider';

/**
 * Serializer for the SiteNonDetect model.
 * @export
 * @interface SiteNonDetect
 */
export interface SiteNonDetect {
    /**
     * 
     * @type {string}
     * @memberof SiteNonDetect
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof SiteNonDetect
     */
    site: string;
    /**
     * 
     * @type {number}
     * @memberof SiteNonDetect
     */
    detectionLimit: number;
    /**
     * 
     * @type {Date}
     * @memberof SiteNonDetect
     */
    timestamp: Date;
    /**
     * 
     * @type {DataProvider}
     * @memberof SiteNonDetect
     */
    dataProvider: DataProvider;
    /**
     * Get the secondary data source.
     * @type {string}
     * @memberof SiteNonDetect
     */
    readonly secondaryDataSource: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiteNonDetect
     */
    scene?: string | null;
}

/**
 * Check if a given object implements the SiteNonDetect interface.
 */
export function instanceOfSiteNonDetect(value: object): value is SiteNonDetect {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('site' in value) || value['site'] === undefined) return false;
    if ((!('detectionLimit' in (value as Record<string, any>)) && !('detection_limit' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionLimit'] === undefined && (value as Record<string, any>)['detection_limit'] === undefined)) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if ((!('dataProvider' in (value as Record<string, any>)) && !('data_provider' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataProvider'] === undefined && (value as Record<string, any>)['data_provider'] === undefined)) return false;
    if ((!('secondaryDataSource' in (value as Record<string, any>)) && !('secondary_data_source' in (value as Record<string, any>))) || ((value as Record<string, any>)['secondaryDataSource'] === undefined && (value as Record<string, any>)['secondary_data_source'] === undefined)) return false;
    return true;
}

export function SiteNonDetectFromJSON(json: any): SiteNonDetect {
    return SiteNonDetectFromJSONTyped(json, false);
}

export function SiteNonDetectFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteNonDetect {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'site': json['site'],
        'detectionLimit': json['detection_limit'],
        'timestamp': (new Date(json['timestamp'])),
        'dataProvider': DataProviderFromJSON(json['data_provider']),
        'secondaryDataSource': json['secondary_data_source'],
        'scene': json['scene'] === undefined ? undefined : json['scene'] === null ? null : json['scene'],
    };
}

export function SiteNonDetectToJSON(json: any): SiteNonDetect {
    return SiteNonDetectToJSONTyped(json, false);
}

export function SiteNonDetectToJSONTyped(value?: Omit<SiteNonDetect, 'id'|'secondaryDataSource'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site': value['site'],
        'detection_limit': value['detectionLimit'],
        'timestamp': value['timestamp'].toISOString(),
        'data_provider': DataProviderToJSON(value['dataProvider']),
        'scene': value['scene'],
    };
}

